import React from "react";
import {
  Typography,
  TypographyProps,
  Button,
  ButtonProps,
  Box,
} from "@mui/material";
import { AuthUser } from "../../services/svc_auth";
import { CustomButtonProps, CustomTypographyProps } from "./_CommonProps";
import SplitButton, { SplitButtonProps } from "./SplitButton";

interface PageHeaderProps {
  backButtonContent?: CustomButtonProps;
  headerTextContent: CustomTypographyProps;
  user: AuthUser | null;
  otherButtons: (CustomButtonProps | SplitButtonProps)[];
  debugPrintValues?: Record<string, unknown>;
}

const PageHeaderComponent: React.FC<PageHeaderProps> = ({
  backButtonContent,
  headerTextContent,
  user,
  otherButtons,
  debugPrintValues,
}) => {
  const handleDebugPrint = () => {
    console.group(`[DEBUG] ${headerTextContent.text}`);
    Object.entries(debugPrintValues!).forEach(([key, value]) => {
      console.log(`${key}:`, value);
    });
    console.groupEnd();
  };

  return (
    <Box display="flex" alignItems="center" gap={2} mb={3}>
      <Box display="flex" alignItems="center" gap={2} mr="auto">
        {backButtonContent && (
          <Button
            id={backButtonContent.id}
            variant={backButtonContent.variant}
            onClick={backButtonContent.onClick}
            startIcon={backButtonContent.startIcon}
            {...backButtonContent.props}
          >
            {backButtonContent.text}
          </Button>
        )}
      </Box>

      <Typography
        {...(headerTextContent.props ?? { variant: "h4", component: "h1" })}
      >
        {headerTextContent.text}
      </Typography>

      <Box display="flex" alignItems="center" gap={2} ml="auto">
        {otherButtons.map((button) =>
          "options" in button ? (
            <SplitButton {...button} />
          ) : (
            <Button
              variant={button.variant}
              onClick={button.onClick}
              startIcon={button.startIcon}
              {...button.props}
            >
              {button.text}
            </Button>
          ),
        )}
        {!!debugPrintValues && user?.is_superuser && (
          <Button variant="outlined" color="warning" onClick={handleDebugPrint}>
            DEBUG PRINT
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PageHeaderComponent;
